import React from "react";
import { Container } from "./styles";


function Index({header, text, btns, footerTheme = false}) {
  const handleFindPrograms = () => {
    window.open("https://app.schooliply.com/#/guest/find-programs", "_blank");
  };
  
  return (
    <>
      <Container background={footerTheme ? "dark" : "light"}>
        <div className="row">
          <div className="content">
            <span>GET STARTED WITH SCHOOLIPLY</span>
            <p className="header-text">{header}</p>
            <span>{text}</span>
            <div className="btn">
              <button onClick={handleFindPrograms}>Start Applying</button>
              {(btns.length > 0) && (
                btns.map((btn) => {
                  return (
                    <button key={btn.text} onClick={btn.onClick}>{btn.text}</button>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default Index;
